
import { Vue, Component } from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { ListDataSource } from "@/data/List/ListDataSource";
import GroupItem from "@/components/common/data/group-item.vue";
import Group from "@/components/common/data/group.vue";
import { Filter } from "@/cms-services/filter";
import stringEditor from "@/components/common/inline-editor/string.vue";
import draggable from "vuedraggable";

@Component({
  components: { GroupItem, Group, stringEditor, draggable },
})
export default class Home extends Vue {
  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "faq",
  });

  get groups() {
    // Создаём копию, чтобы не мутировать оригинал
    return [...(this.dataSource.model?.groups || [])].sort((a, b) => {
      return (a.priority || 0) - (b.priority || 0);
    });
  }
  
  getObjectDataSource(id: number, className: string, model: any) {
    return new ObjectDataSource({
      id: id,
      model: model,
      config: {},
      className: className,
    });
  }
  faqItemDataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
    },
    className: "faqItem",
  });
  faqItemGroupDataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
      filter: JSON.stringify([
        new Filter("faqId", +this.$route.params.id)
      ])
    },
    className: "faqItemGroup",
  });


  async updateGroup() {
    const updatePromises = this.dataSource.model.groups.map((group, index) => {
      
      // Создаем объект обновления: fieldName: 'priority', fieldValue: index
      const updateData = {
        fieldName: 'priority',
        fieldValue: index + 1
      };

      // Получаем dataSource для конкретной группы
      const groupDataSource = this.getObjectDataSource(group.id, 'faqItemGroup', group);

      // Обновляем на сервере
      return groupDataSource.updateField(updateData);
    });

    try {
      await Promise.all(updatePromises);
      console.log('Приоритеты успешно обновлены');
    } catch (err) {
      console.error('Ошибка при обновлении приоритетов:', err);
      
    }
  }
  async updateItem(group){
    const updatePromises = group.items.map((item, index) => {

      // Создаем объект обновления: fieldName: 'priority', fieldValue: index
      const updateData = {
        fieldName: 'priority',
        fieldValue: index + 1
      };

      // Получаем dataSource для конкретной группы
      const groupItemDataSource = this.getObjectDataSource(item.id, 'faqItem', item);

      // Обновляем на сервере
      return groupItemDataSource.updateField(updateData);
    });

    try {
      await Promise.all(updatePromises);
      console.log('Приоритеты успешно обновлены');
    } catch (err) {
      console.error('Ошибка при обновлении приоритетов:', err);

    }
  }
  async addGroup() {
    let item = { caption: `Новая группа ${this.dataSource.model.groups.length}`, faqId: this.dataSource.model.id, priority: this.dataSource.model.groups.length + 1 };
    item = await this.faqItemGroupDataSource.add(item, true);
    this.dataSource.model.groups.push(item);
  }

  async addItem(group: any) {
    let item = { caption: `Новая вопрос ${group.items.length}`, faqItemGroupId: group.id, priority: group.items.length + 1 };
    item = await this.faqItemDataSource.add(item, true);
    group.items.push(item);
  }

  createFaqItem: any = {
    faqId: +this.$route.params.id,
    caption: ""
  }


  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Часто задаваемые вопросы",
        to: "/manage/faq/",
        exact: true,
      },
      {
        text: this.dataSource.model?.caption,
        disabled: true,
      },
    ];
  }
  
  onMounted(){
    if (this.dataSource.model?.groups) {
      console.log("dataSource загрузился")
      this.dataSource.model.groups.forEach(group => {
        if (group.items) {
          // ✅ Сортируем один раз — при загрузке
          group.items.sort((a, b) => (a.priority || 0) - (b.priority || 0));
        }
      });
    }
  }
}
